exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2Q1rl{font-size:24px;font-size:1.5rem;margin-top:0;margin-bottom:32px;margin-bottom:2rem;text-align:center}@media screen and (min-width:480px){._2Q1rl{font-size:2rem}}", ""]);

// exports
exports.locals = {
	"pageTitle": "_2Q1rl"
};